import { render, staticRenderFns } from "./teamStats.vue?vue&type=template&id=2175cedc&scoped=true&"
import script from "./teamStats.vue?vue&type=script&lang=js&"
export * from "./teamStats.vue?vue&type=script&lang=js&"
import style0 from "./teamStats.vue?vue&type=style&index=0&id=2175cedc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2175cedc",
  null
  
)

export default component.exports